import { render, staticRenderFns } from "./use-cases-social-media.vue?vue&type=template&id=2d20c04c&scoped=true"
import script from "./use-cases-social-media.vue?vue&type=script&lang=js"
export * from "./use-cases-social-media.vue?vue&type=script&lang=js"
import style0 from "./use-cases-social-media.vue?vue&type=style&index=0&id=2d20c04c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d20c04c",
  null
  
)

export default component.exports